import React from 'react';
import { Button } from './Button';
import { CheckIcon } from 'lucide-react';
export const ValueStackSection = () => {
  const checkoutUrl = 'https://www.neurotoned.com/offers/6oqdjPAT?coupon_code=7DAYRESETSPECIAL2025';
  return <section className="bg-gradient-to-b from-teal-900 to-teal-800 text-white py-16" data-id="element-354">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-355">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center" data-id="element-356">
          What You Get When You Sign Up Today
        </h2>
        <div className="bg-white bg-opacity-10 p-6 rounded-lg shadow-lg mb-8 max-w-2xl mx-auto" data-id="element-357">
          <div className="space-y-4" data-id="element-358">
            <div className="flex items-center" data-id="element-359">
              <CheckIcon className="w-6 h-6 text-teal-300 mr-3 flex-shrink-0" data-id="element-360" />
              <div data-id="element-361">
                <span className="font-bold text-lg" data-id="element-362">7-Day Guided Reset</span>
                <span className="text-teal-200 ml-2" data-id="element-363">— $39</span>
              </div>
            </div>
            <div className="flex items-center" data-id="element-364">
              <CheckIcon className="w-6 h-6 text-teal-300 mr-3 flex-shrink-0" data-id="element-365" />
              <div data-id="element-366">
                <span className="font-bold text-lg" data-id="element-367">
                  30 Bonus Techniques from Dr. Kim DiRe'
                </span>
                <span className="text-teal-200 ml-2" data-id="element-368">— $25</span>
              </div>
            </div>
            <div className="flex items-center" data-id="element-369">
              <CheckIcon className="w-6 h-6 text-teal-300 mr-3 flex-shrink-0" data-id="element-370" />
              <div data-id="element-371">
                <span className="font-bold text-lg" data-id="element-372">
                  Private Member Community
                </span>
                <span className="text-teal-200 ml-2" data-id="element-373">— $15</span>
              </div>
            </div>
            <div className="flex items-center" data-id="element-374">
              <CheckIcon className="w-6 h-6 text-teal-300 mr-3 flex-shrink-0" data-id="element-375" />
              <div data-id="element-376">
                <span className="font-bold text-lg" data-id="element-377">Lifetime Access</span>
                <span className="text-teal-200 ml-2" data-id="element-378">— $10</span>
              </div>
            </div>
            <div className="border-t border-teal-600 pt-4 mt-4" data-id="element-379">
              <div className="flex items-center justify-between" data-id="element-380">
                <span className="font-bold text-lg" data-id="element-381">Total Value:</span>
                <span className="font-bold text-lg" data-id="element-382">$89</span>
              </div>
            </div>
            <div className="bg-teal-600 p-4 rounded-lg relative" data-id="element-383">
              <div className="absolute -top-3 -right-3 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-384">
                LIMITED TIME
              </div>
              <div className="flex items-center justify-between" data-id="element-385">
                <span className="font-bold text-lg" data-id="element-386">Today Only:</span>
                <span className="font-bold text-2xl" data-id="element-387">$9</span>
              </div>
              <div className="text-center mt-1 text-white" data-id="element-388">
                One-Time Payment
              </div>
            </div>
          </div>
        </div>
        <p className="text-center text-lg mb-6" data-id="element-389">
          Already Know The Science? Now You'll Feel the Shift — With Just One
          Week of Daily Body-Based Practice.
        </p>
        <div className="flex justify-center" data-id="element-390">
          <Button link={checkoutUrl} data-id="element-391">Try the 7-Day Reset – Just $9 ➔</Button>
        </div>
      </div>
    </section>;
};